export default "__VITE_ASSET__BavXOdz2__"